module.exports = __webpack_public_path__ + "static/media/hr1-helmet.9561f449.glb";